import u from "umbrellajs";
import {
  signIn,
  logOut,
  recoveryPassword,
  recoveryPasswordMobile,
  savePasswordChange,
} from "./login";
import {
  toggleShowOrHidePass,
  showPasswordRecovery,
  showSigIn,
  loadMoreInformation,
} from "./lib/Utils";
import { showOverlay, hideModal } from "./modal";

window.addEventListener("load", function () {
  if (window.location.host.includes("fie")) {
    const isDesktop = window.innerWidth > 767;
    if (isDesktop) {
      let $contentVideo = document.getElementById("content-desktop-video");

      let video = document.createElement("video");
      video.className = "vid-desktop no-visible ";
      // video.title = "Abre tu cuenta con un click - Banco FIE";
      video.autoplay = true;
      video.loop = false;
      video.muted = true;
      video.playsInline = true;

      let sourceWebM = document.createElement("source");
      sourceWebM.src = "/app/images/frontend/fie/FIECerditoDesktop.webm";
      sourceWebM.type = "video/webm";
      video.appendChild(sourceWebM);

      let sourceMP4 = document.createElement("source");
      sourceMP4.src = "/app/images/frontend/fie/FIECerditoDesktop.mp4";
      sourceMP4.type = "video/mp4";
      video.appendChild(sourceMP4);

      $contentVideo.appendChild(video);

      video.addEventListener("loadeddata", function () {});

      video.addEventListener("canplaythrough", function () {
        let $videoCover = document.getElementById("bg-desktop-initial");
        $videoCover.classList.add("hidden");
        this.classList.remove("no-visible");
        this.play();
      });
    } else {
      let $contentVideo = document.getElementById("content-video");

      let video = document.createElement("video");
      video.className = "vid-mobile no-visible ";
      // video.title = "Abre tu cuenta con un click - Banco FIE";
      video.autoplay = true;
      video.loop = false;
      video.muted = true;
      video.playsInline = true;

      let sourceWebM = document.createElement("source");
      sourceWebM.src = "/app/images/frontend/fie/FIECerditoMobile.webm";
      sourceWebM.type = "video/webm";
      video.appendChild(sourceWebM);

      let sourceMP4 = document.createElement("source");
      sourceMP4.src = "/app/images/frontend/fie/FIECerditoMobile.mp4";
      sourceMP4.type = "video/mp4";
      video.appendChild(sourceMP4);

      $contentVideo.appendChild(video);

      video.addEventListener("loadeddata", function () {});

      video.addEventListener("canplaythrough", function () {
        let $videoCover = document.getElementById("bg-initial");
        $videoCover.classList.add("hidden");
        this.classList.remove("no-visible");
        this.play();
      });
    }
  }
});

window.addEventListener("load", function () {
  u("#headerPhp").on("click", ".sign-in", function () {
    const isDesktop = window.innerWidth > 767;

    if (isDesktop) {
      fetch(`${MAIN_WEB_ROOT}ajax/app/custom/users/loginPanelHome`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "html",
      })
        .then((response) => response.text())
        .then((response) => {
          showOverlay();
          u(".modal-custom")
            .find(".modal-custom-background__modal--content")
            .html(response);

          u(".modal-custom").addClass("active");

          setTimeout(function () {
            u(
              ".modal-custom .modal-custom-background .modal-custom-background__modal .modal-custom-background__modal--svg"
            ).nodes[0].style.opacity = 0;
          }, 700);

          u("body").nodes[0].style.overflow = "hidden";
        });
    }
  });

  u(".modal-custom").on("click", "#modalBtnClose", function () {
    hideModal();
  });

  u("body").on("click", ".show-password", function (e) {
    const $input = u(this).siblings("input");
    toggleShowOrHidePass($input);
  });

  u("body").on("click", "#btnRecoverPassword", function () {
    showPasswordRecovery();
  });

  u("body").on("click", ".cancel-btn", function () {
    showSigIn();
  });

  u("body").on("click", ".cancel-change-password-btn", function () {
    hideModal();
  });

  u("body").on("submit", "#formSignIn", function (e) {
    e.preventDefault();
    const isCRM = u(".ucr-hero_content--right").length > 0;
    const isMobile = u(".layout-login-mobile").length > 0;
    signIn(isMobile, isCRM);
  });

  u("body").on("submit", "#formPasswordRecovery", function (e) {
    e.preventDefault();
    recoveryPassword();
  });

  u("body").on("submit", "#passwordToken", function (e) {
    e.preventDefault();
    savePasswordChange();
  });

  u("body").on("submit", "#formPasswordRecoveryMobile", function (e) {
    e.preventDefault();
    recoveryPasswordMobile();
  });

  u("#headerPhp").on("click", ".container-options .dropdown", function (e) {
    u(".container-options .dropdown").toggleClass("open");
  });

  u("#headerPhp").on("click", ".container-options #logOut", function (e) {
    logOut();
  });

  u("#headerPhp").on("click", "#menu-mobile", function (e) {
    u("#headerPhp .sliding-menu").addClass("active");
  });

  u("#headerPhp").on(
    "click",
    ".sliding-menu .btn-close-menu-mobile",
    function (e) {
      u("#headerPhp .sliding-menu").removeClass("active");
    }
  );

  u("body").on("click", ".ucr-gallery-images--button", function (e) {
    loadMoreInformation();
  });

  u("body").on("click", ".sliding-menu-body .menu", function (e) {
    e.preventDefault();
    u(this).toggleClass("open");

    return false;
  });
});
